function generateEnumsFromKeys<T extends Record<string, any>>(obj: T) {
  return Object.keys(obj).reduce(
    (enums: any, key) => {
      enums[key] = key;
      return enums;
    },
    {} as Record<keyof T, string>
  );
}

type ModelKeys<T> = Record<keyof T, string>;

const HGetKeyEnums = <T>(obj: T): ModelKeys<T> => {
  return generateEnumsFromKeys(obj as any);
};

export { HGetKeyEnums };
